module.exports = __webpack_public_path__ + "static/media/chat-icon.b0bb3021.svg";